export const sum1And2 = (data, field) => {

  let sum1And2 = 0
  data?.part_1?.data.forEach(row => {
    sum1And2 += (+row[field])
  })
  data?.part_2?.data?.forEach(row => {
    sum1And2 += (+row[field])
  })

  return sum1And2
}
export const sum3 = (data, field) => {
  let sum3 = 0
  data?.part_3?.data?.forEach(row => {
    sum3 += (+row[field])
  })
  return sum3
}
export const sum1 = (data, field) => {
  let sum3 = 0
  data?.part_1?.data?.forEach(row => {
    sum3 += (+row[field])
  })
  return sum3
}
export const sum2 = (data, field) => {
  let sum2 = 0
  data?.part_2?.data?.forEach(row => {
    sum2 += (+row[field])
  })
  return sum2
}
export const sumFinalRemainSum = (data, field) => {
  return sum1And2(data, field) + sum3(data, field)
}
